import type { Product } from '../types';
import { ProductCard } from './ProductCard';

export function ProductGrid({ products, emptyMessage = 'Nenhuma peça encontrada com estes filtros.' }: { products: Product[]; emptyMessage?: string }) {
  if (!products.length) return <div className="empty-state"><p>{emptyMessage}</p></div>;
  return <div className="product-grid">{products.map((product) => <ProductCard key={product.id} product={product} />)}</div>;
}
